import { Cell, Funnel, FunnelChart, LabelList, ResponsiveContainer, Tooltip } from 'recharts';

import { chartTooltipStyle } from '@/features/reports/lib/chartTheme';
import { formatNumber, formatPercent, formatToman } from '@/features/reports/lib/format';

/** Status colours: pipeline stages in order, failures pulled out in red. */
export const STATUS_COLORS = {
    pending: '#90A4AE',
    processing: '#1E88E5',
    shipped: '#F59E0B',
    delivered: '#2E7D32',
    failed: '#D32F2F',
};

/**
 * Order pipeline funnel.
 *
 * The backend deliberately reports every status here — including failures —
 * because a funnel that hides its failures cannot be acted on.
 */
export default function OrderFunnelChart({ rows = [], height = 320 }) {
    const data = rows.map((row) => ({
        ...row,
        name: row.label,
        fill: STATUS_COLORS[row.status] ?? '#546E7A',
    }));

    const tooltip = ({ active, payload }) => {
        if (!active || !payload?.length) return null;
        const row = payload[0].payload;
        return (
            <div className="report-tooltip">
                <p className="report-tooltip-title">{row.label}</p>
                <p className="report-tooltip-row">
                    <span>تعداد</span>
                    <strong>{formatNumber(row.count)}</strong>
                </p>
                <p className="report-tooltip-row report-tooltip-muted">
                    <span>سهم</span>
                    <span>{formatPercent(row.share_pct)}</span>
                </p>
                <p className="report-tooltip-row report-tooltip-muted">
                    <span>مبلغ</span>
                    <span>{formatToman(row.revenue)}</span>
                </p>
            </div>
        );
    };

    return (
        <div style={{ width: '100%', height }}>
            <ResponsiveContainer width="100%" height="100%">
                <FunnelChart margin={{ top: 10, right: 90, left: 10, bottom: 10 }}>
                    <Tooltip content={tooltip} contentStyle={chartTooltipStyle} />
                    <Funnel dataKey="count" data={data} isAnimationActive>
                        <LabelList
                            position="right"
                            dataKey="label"
                            fill="var(--text-primary)"
                            stroke="none"
                            style={{ fontFamily: 'var(--font)', fontSize: 12 }}
                        />
                        {data.map((row) => (
                            <Cell key={row.status} fill={row.fill} />
                        ))}
                    </Funnel>
                </FunnelChart>
            </ResponsiveContainer>
        </div>
    );
}
